import { alphaNumeric } from 'shared/regex/regex';
import * as yup from 'yup';
import { FIELD_NAMES, POLICY_ANSWERS } from './types';

const radioQuestionsArray = [
  FIELD_NAMES.FINANCIAL_CRIME_POLICY,
  FIELD_NAMES.DATA_PROTECTION_POLICY,
  FIELD_NAMES.TREATING_CUSTOMER_FAIRLY_POLICY,
  FIELD_NAMES.DISASTER_RECOVERY_POLICY,
  FIELD_NAMES.EMPLOYEE_ACCESS_REMOVAL_PROCESS,
  FIELD_NAMES.PII_IN_PLACE_WITH_FCA_REQUIREMENTS,
  FIELD_NAMES.SENSITIVE_DATA_POLICY,
];

export const validationSchema = () =>
  yup.object().shape({
    [FIELD_NAMES.COMPANIES_HOUSE_NUMBER]: yup
      .string()
      .nullable()
      .required('This field is required')
      .matches(alphaNumeric, 'Please us characters and numbers only')
      .test('Max 8 characters', 'Maximum 8 characters and/or digits only', (val) => val && val.length <= 8),
    [FIELD_NAMES.ICO_PROTECTION_NUMBER]: yup
      .string()
      .nullable()
      .required('This field is required')
      .matches(alphaNumeric, 'Please us characters and numbers only')
      .test('Max 10 characters', 'Maximum 10 characters only', (val) => val && val.length <= 10),
    [FIELD_NAMES.NUMBER_OF_COMPLAINTS_RECEIVED]: yup
      .number()
      .nullable()
      .required('This field is required')
      .max(999, 'Maximum 3 digits only'),
    [FIELD_NAMES.NUMBER_OF_COMPLAINTS_UPHELD]: yup
      .number()
      .nullable()
      .when([FIELD_NAMES.NUMBER_OF_COMPLAINTS_RECEIVED], {
        is: (val) => val !== 0 && val !== null,
        then: yup
          .number()
          .nullable()
          .required('This field is required')
          .max(999, 'Maximum 3 digits only'),
      }),
    [FIELD_NAMES.FINANCIAL_CRIME_POLICY]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.DATA_PROTECTION_POLICY]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.TREATING_CUSTOMER_FAIRLY_POLICY]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.DISASTER_RECOVERY_POLICY]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.EMPLOYEE_ACCESS_REMOVAL_PROCESS]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.PII_IN_PLACE_WITH_FCA_REQUIREMENTS]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.SENSITIVE_DATA_POLICY]: yup
      .string()
      .nullable()
      .required('This field is required'),
    [FIELD_NAMES.ADDITIONAL_INFORMATION]: yup
      .string()
      .nullable()
      .when(radioQuestionsArray, {
        is: (...values) => values.includes(POLICY_ANSWERS.NO) || values.includes(POLICY_ANSWERS.DONT_KNOW),
        then: yup
          .string()
          .nullable()
          .required("This field is required if you answered No or Don't know to any questions above"),
      }),
    [FIELD_NAMES.AGREED_TO_TERMS_AND_CONDITIONS]: yup
      .bool()
      .nullable()
      .oneOf([true], 'Acceptance of the Terms of Business is required in order to register your firm'),
    [FIELD_NAMES.WHO_CARRIES_COMPLIANCE_OVERSIGHT]: yup.string().nullable(),
  });
